export default __webpack_public_path__ + "static/media/step-three-2.90f8a646.svg";